import * as React from "react";
import {cx} from "emotion";
import {cs} from "@Common/react/chain-services";

import {SubscribeButton} from "../subscribe-button/subscribe-button";
import "./subscriptions-details-mobile.scss";
import {formatMoney} from "@Common/ui-components/language/format-money";
import { PLAN_TYPE } from "../subscriptions-details";

export const SubscriptionsDetailsMobile = ({selectedPlanId, perks, subscriptionPlans, subscriptionModal}) => cs(
    ({}) => (
        <div className="subscriptions-details-mobile-84e">
            <div className="top" style={{backgroundImage: `url(${require("../images/mobile-background.svg")})`}}>
                <div className="yellow-square"/>
                <div className="top-child heading" xd-qa-type="label" xd-qa-name="Introducing">
                    Introducing
                    <div className="logo" xd-qa-type="logo" xd-qa-name="XD Logo">
                        <img alt="XD+" src={require("../images/xdplus-logo-white.svg")}/>
                    </div>
                </div>
                <div className="top-child sub-heading-1" xd-qa-type="label" xd-qa-name="Subscribe to receive exclusive benefits and instant savings!">
                    <div className="text">
                        Subscribe to receive exclusive benefits and instant savings!
                    </div>
                </div>
            </div>
                <div className="middle">
                    <div className="blue-square"/>
                    <div className="perks">
                        <div className="line-1">
                            <div className="perk" key={0}>
                                <div className="icon-circle" xd-qa-type="icon" xd-qa-name={perks[0].line2 + " Icon"}>
                                    <img alt={perks[0].line2} src={perks[0].icon}/>
                                </div>
                                <div className="perk-line-1" xd-qa-type="text" xd-qa-name={perks[0].line1 + " " + perks[0].line2}>{perks[0].line1}</div>
                                <div className="perk-line-2" xd-qa-type="text" xd-qa-name={perks[0].line2}>
                                    {perks[0].line2}
                                    {perks[0].asterisk && <span className="asterisk">*</span>}
                                </div>
                            </div>
                            <div className="perk" key={1}>
                                <div className="icon-circle" xd-qa-type="icon" xd-qa-name={perks[1].line2 + " Icon"}>
                                    <img alt={perks[1].line2} src={perks[1].icon}/>
                                </div>
                                <div className="perk-line-1" xd-qa-type="text" xd-qa-name={perks[1].line1 + " " + perks[1].line2}>{perks[1].line1}</div>
                                <div className="perk-line-2" xd-qa-type="text" xd-qa-name={perks[1].line2}>
                                    {perks[1].line2}
                                    {perks[1].asterisk && <span className="asterisk">*</span>}
                                </div>
                            </div>
                        </div>
                        <div className="line-2">
                            <div className="perk" key={2}>
                                <div className="icon-circle" xd-qa-type="icon" xd-qa-name={perks[2].line2 + " Icon"}>
                                    <img alt={perks[2].line2} src={perks[2].icon}/>
                                </div>
                                <div className="perk-line-1" xd-qa-type="text" xd-qa-name={perks[2].line1 + " " + perks[2].line2}>{perks[2].line1}</div>
                                <div className="perk-line-2" xd-qa-type="text" xd-qa-name={perks[2].line2}>
                                    {perks[2].line2}
                                    {perks[2].asterisk && <span className="asterisk">*</span>}
                                </div>
                            </div>
                            <div className="perk" key={3}>
                                <div className="icon-circle" xd-qa-type="icon" xd-qa-name={perks[3].line2 + " Icon"}>
                                    <img alt={perks[3].line2} src={perks[3].icon}/>
                                </div>
                                <div className="perk-line-1" xd-qa-type="text" xd-qa-name={perks[3].line1 + " " + perks[3].line2}>{perks[3].line1}</div>
                                <div className="perk-line-2" xd-qa-type="text" xd-qa-name={perks[3].line2}>
                                    {perks[3].line2}
                                    {perks[3].asterisk && <span className="asterisk">*</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                <div className="plans">
                    {subscriptionPlans.value && subscriptionPlans.value.pricePoints.map((plan) =>
                        <div className="plan-wrapper" key={plan.id}>
                            <div
                                className={cx("plan",{selected: selectedPlanId.value === plan.idChargebeePricePoint, "best-value": plan.idPlanType === PLAN_TYPE.YEAR})}
                                xd-qa-type="card"
                                xd-qa-name={plan.idChargebeePricePoint}
                                onClick={() => selectedPlanId.onChange(plan.idChargebeePricePoint)}
                            >
                                <div className="name" xd-qa-type="label" xd-qa-name="Name">{plan.name}</div>
                                <div className="description" xd-qa-type="label" xd-qa-name="Description">{plan.description}</div>
                                <div className="right">
                                    <div className="cost" xd-qa-type="label" xd-qa-name="Price">{formatMoney((plan.priceCents / 100), {alwaysShowDollarSymbol: true})}</div>
                                </div>
                            </div>
                            {selectedPlanId.value === plan.idChargebeePricePoint &&
                            <div className="check" xd-qa-type="icon" xd-qa-name="Selected Check">
                                <i className="fa fa-check"/>
                            </div>}
                        </div>
                    )}
                </div>
                {SubscribeButton({subscriptionModal, planId: selectedPlanId.value})}
            </div>
        </div>
    ),
);

